import { useSearchParams } from "next/navigation";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import ButtonClose from "./ButtonClose";
import { GetIdTag } from "../interface/type";
import { scrollIntoViewById } from "../utils/scrollIntoTheView";

export interface IndexProps {
  indexs: Array<GetIdTag>;
}

export default function IndexButton({ indexs }: IndexProps) {
  const searchParams = useSearchParams();
  const [isOpenModalIndexs, setIsOpenModalIndexs] = useState(false);
  const [byIds, setByIds] = useState<Array<GetIdTag>>([]);

  const closeModalIndexs = () => {
    setIsOpenModalIndexs(false);
  }

  const openModalIndexs = () => {
    setIsOpenModalIndexs(true);
  }

  useEffect(() => {
    setByIds([...indexs]);
  }, [indexs]);

  const renderMotalAmenities = () => {
    return (
      <Transition appear show={isOpenModalIndexs} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalIndexs}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
            </Transition.Child>

            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-8 w-full max-w-sm sm:max-w-lg">
                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                    <h3
                      className="text-lg font-medium leading-6 text-gray-900"
                      id="headlessui-dialog-title-70"
                    >
                      목차
                    </h3>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={closeModalIndexs} />
                    </span>
                  </div>
                  <div className="overflow-auto text-neutral-700 dark:text-neutral-300 ">
                    {byIds.map((item) => (
                      <div
                        key={item.id}
                        className="px-8 flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8 cursor-pointer hover:bg-gray-200"
                        onClick={() => {
                          scrollIntoViewById(item.id);
                          closeModalIndexs();
                        }}
                      >
                        <i
                          className={`text-4xl text-neutral-6000 las`}
                        ></i>
                        <span>{item.type === 2 ? item.name : <>
                          <span className="pl-3">{`└ ${item.name}`}</span>
                        </>}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  return <>
    {searchParams.get("isIndex") == null ? <></> : <div
      className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100"
    >
      <button
        className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100"
        onClick={openModalIndexs}
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
      </button>
    </div>}
    {renderMotalAmenities()}
  </>;
}